const EditIcon = () => (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="36" height="36" rx="18" fill="white" />
        <path d="M8.99947 26.4891H10.7176L21.3029 15.9039L19.5847 14.1857L8.99947 24.7709V26.4891ZM26.5495 14.1243L21.3336 8.96976L23.0517 7.25158C23.5222 6.78113 24.1 6.5459 24.7853 6.5459C25.4705 6.5459 26.0483 6.78113 26.5188 7.25158L28.237 8.96976C28.7074 9.44022 28.9529 10.0078 28.9733 10.6726C28.9938 11.3374 28.7688 11.905 28.2983 12.3754L26.5495 14.1243ZM24.7699 15.9345L11.7608 28.9436H6.54492V23.7277L19.554 10.7186L24.7699 15.9345Z" fill="#3FABD5" />
    </svg>

);

export default EditIcon;
